export const FILTERS_TRANSLATIONS = {
  filtering: "Filtering",
  routeType: "routeType",
  allRouteTypes: "allRouteTypes",
  hiking: "hiking",
  biking: "biking",
  regions: "regions",
  categoryGroups: [
    {
      id: "1",
      name: "Accommodation",
      categories: [
        { id: "1", name: "Campsites" },
        { id: "2", name: "Shelter" },
        { id: "3", name: "B&B" },
        { id: "4", name: "Hotels" },
        { id: "5", name: "GuestHouses" },
        { id: "6", name: "HolidayFlats" },
        { id: "7", name: "Kroer" },
        { id: "8", name: "CampingPitches" },
        { id: "9", name: "CampSchools" },
        { id: "10", name: "Farmhouse" },
        { id: "11", name: "Untraditional" },
      ],
    },
    {
      id: "2",
      name: "Faciliteter",
      categories: [
        { id: "12", name: "Toilets" },
        { id: "13", name: "Hydrants" },
        { id: "14", name: "Tables&Benches" },
        { id: "15", name: "BreakPoints" },
        { id: "19", name: "CampfirePits" },
        { id: "17", name: "BicyclePumpingStations" },
        // ladestationer ???
        { id: "18", name: "Parking" },
        { id: "35", name: "TuristInformation" },
      ],
    },
    {
      id: "3",
      name: "Gastronomy",
      categories: [
        { id: "21", name: "Cafee" },
        { id: "22", name: "Restaurants" },
        { id: "23", name: "Local" },
      ],
    },
    {
      id: "5",
      name: "Purchases",
      categories: [
        { id: "28", name: "Purchases" },
        { id: "20", name: "Pharmacists" },
      ],
    },
    {
      id: "4",
      name: "Attractions",
      categories: [
        { id: "24", name: "Churches&Monasteries" },
        { id: "25", name: "Museums" },
        { id: "26", name: "Monuments&Ruins" },
        { id: "27", name: "Castles&Manors" },
        { id: "29", name: "Hærvejspas" },
        { id: "30", name: "SkulpturerOgStreetArt" },
        { id: "31", name: "HaverOgParker" },
        { id: "32", name: "ArkitekturOgByrum" },
        { id: "33", name: "Beaches" },
        { id: "34", name: "Fishing" },
      ],
    },
  ],
};
